import React, { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import WeduTooltip from "../../../../components/WeduTooltip/intex";
import IconButton from "../../../../components/IconButton";
import FontIcon from "../../../../components/FontIcon";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
  },
  iconButtonCont: {
    "& + &": {
      marginLeft: 16,
    },
  },
  message: {
    padding: 5,
    "& .MuiIcon-root": {
      fontSize: 14,
    },
  },
  view: {
    padding: 5,
    "& .MuiIcon-root": {
      fontSize: 14,
    },
  },
  edit: {
    padding: 6,
    "& .MuiIcon-root": {
      fontSize: 12,
    },
  },
  cancel: {
    padding: 6,
    "& .MuiIcon-root": {
      fontSize: 12,
    },
  },
  redirect: {
    padding: 5,
    "& .MuiIcon-root": {
      fontSize: 14,
    },
  },
}));

interface IActionButtonProps {
  goToMessages?: () => any;
  messageTooltip?: string;
  viewApp?: () => any;
  viewTooltip?: string;
  editApp?: () => any;
  editTooltip?: string;
  disableEdit?: boolean;
  cancelApp?: () => any;
  cancelTooltip?: string;
  disableCancel?: boolean;
  redirect?: () => any;
  redirectTooltip?: string;
}

export const ActionButton: FC<IActionButtonProps> = ({
  goToMessages,
  messageTooltip,
  viewApp,
  viewTooltip,
  editApp,
  editTooltip,
  disableEdit,
  cancelApp,
  cancelTooltip,
  disableCancel,
  redirect,
  redirectTooltip,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {!!goToMessages && (
        <div className={classes.iconButtonCont}>
          <WeduTooltip title={messageTooltip}>
            <IconButton
              className={classes.message}
              color={"message"}
              onClick={goToMessages}
            >
              <FontIcon name={"message"} />
            </IconButton>
          </WeduTooltip>
        </div>
      )}
      {!!viewApp && (
        <div className={classes.iconButtonCont}>
          <WeduTooltip title={viewTooltip}>
            <IconButton
              className={classes.view}
              color={"info"}
              onClick={viewApp}
            >
              <FontIcon name={"show"} />
            </IconButton>
          </WeduTooltip>
        </div>
      )}
      {!!editApp && (
        <div className={classes.iconButtonCont}>
          <WeduTooltip title={disableEdit ? "" : editTooltip}>
            <IconButton
              className={classes.edit}
              color={"edit"}
              onClick={editApp}
              disabled={disableEdit}
            >
              <FontIcon name={"edit"} />
            </IconButton>
          </WeduTooltip>
        </div>
      )}
      {!!cancelApp && (
        <div className={classes.iconButtonCont}>
          <WeduTooltip title={disableCancel ? "" : cancelTooltip}>
            <IconButton
              className={classes.cancel}
              color={"delete"}
              onClick={cancelApp}
              disabled={disableCancel}
            >
              <FontIcon name={"reset"} />
            </IconButton>
          </WeduTooltip>
        </div>
      )}
      {!!redirect && (
        <div className={classes.iconButtonCont}>
          <WeduTooltip title={redirectTooltip}>
            <IconButton
              className={classes.redirect}
              color={"success"}
              onClick={redirect}
            >
              <FontIcon name={"go"} />
            </IconButton>
          </WeduTooltip>
        </div>
      )}
    </div>
  );
};
